const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

export const getOrganizationSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '合同会社デジポップ',
  url: siteUrl,
  logo: `${siteUrl}/vite.svg`,
  description: '高知県を中心に四国エリアでDX支援、SNS運用代行、デジタルマーケティング支援を提供する企業',
  address: {
    '@type': 'PostalAddress',
    streetAddress: '土佐山田町西本町1丁目5番26号',
    addressLocality: '香美市',
    addressRegion: '高知県',
    postalCode: '782-0033',
    addressCountry: 'JP'
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 33.6025,
    longitude: 133.6819
  },
  areaServed: [
    {
      '@type': 'State',
      name: '高知県'
    },
    {
      '@type': 'State',
      name: '香川県'
    },
    {
      '@type': 'State',
      name: '愛媛県'
    },
    {
      '@type': 'State',
      name: '徳島県'
    },
    {
      '@type': 'City',
      name: '広島市'
    },
    {
      '@type': 'City',
      name: '岡山市'
    },
    {
      '@type': 'City',
      name: '神戸市'
    },
    {
      '@type': 'State',
      name: '大阪府'
    },
    {
      '@type': 'State',
      name: '東京都'
    }
  ]
});

export const getLocalBusinessSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  '@id': `${siteUrl}/#localbusiness`,
  name: '合同会社デジポップ',
  image: `${siteUrl}/vite.svg`,
  url: siteUrl,
  telephone: '',
  priceRange: '$$',
  address: {
    '@type': 'PostalAddress',
    streetAddress: '土佐山田町西本町1丁目5番26号',
    addressLocality: '香美市',
    addressRegion: '高知県',
    postalCode: '782-0033',
    addressCountry: 'JP'
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 33.6025,
    longitude: 133.6819
  },
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
      opens: '09:00',
      closes: '18:00'
    }
  ]
});

export const getServiceSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'Service',
  serviceType: 'DX支援・SNS運用代行・デジタルマーケティング支援',
  provider: {
    '@type': 'Organization',
    name: '合同会社デジポップ',
    url: siteUrl
  },
  areaServed: {
    '@type': 'Country',
    name: '日本'
  },
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: 'DX支援サービス',
    itemListElement: [
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'SNS運用代行',
          description: 'Instagram、Facebook、X（旧Twitter）などのSNS運用を代行し、集客とブランディングをサポート'
        }
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'DX推進支援',
          description: 'デジタル技術を活用した業務効率化と新しい価値創造をサポート'
        }
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: '生成AI活用サポート',
          description: 'ChatGPTなどの生成AIを活用した業務効率化をサポート'
        }
      }
    ]
  }
});

export const getFAQSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'DXとは何ですか？難しそうで不安です。',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'DX（デジタルトランスフォーメーション）とは、デジタル技術を活用して業務を効率化したり、新しい価値を生み出すことです。難しく考える必要はありません。例えば、紙の書類をデジタル化したり、SNSで集客したりすることもDXの一つです。私たちは専門用語を使わず、分かりやすくサポートいたします。'
      }
    },
    {
      '@type': 'Question',
      name: 'ITに詳しくなくても大丈夫ですか？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'はい、全く問題ありません。むしろITに詳しくない方こそ、私たちのサービスをご活用いただきたいと考えています。専門用語を使わず、一つひとつ丁寧にご説明しながら進めていきます。パソコンやスマートフォンの基本操作ができれば十分です。'
      }
    },
    {
      '@type': 'Question',
      name: 'どのくらいの期間で効果が出ますか？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '取り組む内容によって異なりますが、SNS運用であれば3〜6ヶ月程度で効果を実感いただけることが多いです。業務効率化については、導入直後から時間短縮を実感いただけます。焦らず、お客様のペースに合わせて進めていきますのでご安心ください。'
      }
    },
    {
      '@type': 'Question',
      name: '費用はどのくらいかかりますか？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'サービス内容やご要望によって異なります。まずは無料相談で現状をお聞かせいただき、最適なプランをご提案いたします。補助金・助成金の活用もサポートしておりますので、費用面でのご不安もお気軽にご相談ください。'
      }
    },
    {
      '@type': 'Question',
      name: '対面とオンライン、どちらで対応してもらえますか？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '四国エリア（高知・香川・愛媛・徳島）、広島市、岡山市、神戸市、大阪府、東京都は対面での伴走支援が可能です。その他のエリアはオンライン（Zoom等）での対応となります。オンラインでも対面と変わらない質のサポートを提供いたします。'
      }
    },
    {
      '@type': 'Question',
      name: '契約期間の縛りはありますか？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '最低契約期間は6ヶ月からとなっております。DXの取り組みは一定期間継続することで効果が現れるため、まずは6ヶ月間しっかりとサポートさせていただきます。その後は、お客様の状況に応じて柔軟に対応いたします。'
      }
    }
  ]
});

export const getWebPageSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  '@id': `${siteUrl}/#webpage`,
  url: siteUrl,
  name: '高知県DX支援 SNS運用代行 デジタルマーケティング 合同会社デジポップ',
  description: '高知県を中心に四国エリアでDX支援、SNS運用代行、デジタルマーケティング支援を提供。ITに詳しくない経営者様も安心の伴走型サポート。無料相談受付中。対面・オンライン対応可能。',
  inLanguage: 'ja',
  isPartOf: {
    '@type': 'WebSite',
    '@id': `${siteUrl}/#website`,
    url: siteUrl,
    name: '合同会社デジポップ'
  }
});

export const getBreadcrumbSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      name: 'ホーム',
      item: siteUrl
    }
  ]
});
